import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconEmail = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 567.9 496.9" {...props}>
      <g fill="#e5ebed">
        <ellipse cx="391.4" cy="486" rx="131.5" ry="6" />
        <ellipse cx="57.4" cy="439" rx="49" ry="6" />
        <path d="M57.4 78.1h502.8V384H57.4z" />
      </g>
      <path fill="#fff" d="M57.4 46.2h502.8v31.9H57.4z" />
      <g fill="#c2d2da">
        <path d="M561.7 79.6H55.9V44.7h505.8v34.9zm-502.8-3h499.8V47.7H58.9v28.9z" />
        <path d="M561.7 385.6H55.9v-309h505.8v309zm-502.8-3h499.8v-303H58.9v303z" />
        <circle cx="80.6" cy="62" r="4" />
        <circle cx="97" cy="62" r="4" />
        <circle cx="113.4" cy="62" r="4" />
        <path d="M83.1 107.4h68.7V130H83.1z" />
      </g>
      <g fill="#dae4e7">
        <path d="M83.1 146.3h52v11.3h-52zm104.6-38.9H499V130H187.7zm0 38.9H499v22.6H187.7zm0 38.9H499v22.6H187.7zm0 38.9H499v22.6H187.7zm0 38.9H499v22.6H187.7zm0 38.9H499v22.6H187.7zm-104.6-128h52v11.3h-52zm0 27.6h52v11.3h-52z" />
        <path d="M83.1 229.1h52v11.3h-52z" />
      </g>
      <path fill="#dee9ef" d="M333 160h169.5v180.8H333z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M504 342.3H331.5V158.5H504v183.8zm-169.5-3H501V161.5H334.5v177.8z"
      />
      <path fill="#fff" d="M304.9 269.6l-43.6 25.3v149.2h261.6V294.9l-43.6-25.3" />
      <path fill="#fff" d="M304.9 319.3V182.4h174.4v136.1" />
      <g fill={theme.colors.accent}>
        <path d="M524.4 445.6H259.8V294.1l44.4-25.8 1.5 2.6-42.9 24.9v146.8h258.6V295.8l-42.8-24.9 1.5-2.6 44.3 25.8z" />

        <path d="M306.4 319.3h-3V180.9h177.4v137.6h-3V183.9H306.4z" />
        <path d="M260.5 296.2l1.5-2.6 261.6 149.2-1.5 2.6z" />
        <path d="M388 366l134.3-72.4 1.4 2.6-134.4 72.4zM348.5 233.3h87.2v3h-87.2zm0 43.6h87.2v3h-87.2z" />
      </g>
      <path fill="#fff" d="M8.6 314.8h97.5v68H8.6z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M107.6 384.3H7.1v-71h100.5v71zm-97.5-3h94.5v-65H10.1v65z"
      />
      <path fill="#fff" d="M8.6 382.8h97.5v15.5H8.6z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M107.6 399.8H7.1v-18.5h100.5v18.5zm-97.5-3h94.5v-12.5H10.1v12.5z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M57.4 367a9.6 9.6 0 0 1-9.5-9.5V340c0-5.2 4.3-9.5 9.5-9.5s9.5 4.3 9.5 9.5v17.5c0 5.3-4.3 9.5-9.5 9.5zm0-33.5a6.5 6.5 0 0 0-6.5 6.5v17.5a6.5 6.5 0 1 0 13 0V340c0-3.5-2.9-6.5-6.5-6.5zm26-17.2H31.3v-22.8a26.1 26.1 0 0 1 52.2 0v22.8zm-49.1-3h46.1v-19.8a23.1 23.1 0 0 0-46.2 0v19.8z"
      />
      <path fill="#fff" d="M147.9 6.5H305v88.9H147.9z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M306.4 96.9h-160V5h160.1v91.9zm-157-3h154.1V8H149.4v85.9z"
      />
      <path
        fill="#c2d2da"
        d="M189 39.6l9.4 9.4-9.4 9.4-9.4-9.4zM214 39.6l9.3 9.4-9.4 9.4-9.4-9.4zM238.9 39.6l9.4 9.4-9.4 9.4-9.4-9.4zM263.9 39.6l9.4 9.4-9.4 9.4-9.4-9.4z"
      />
    </SvgIcon>
  );
};

export default IconEmail;
